import React from 'react';
import PropTypes from 'prop-types';

export default function IconBlockUser({ className }) {
  return (
    <svg className={className} fill="none" height="17" viewBox="0 0 17 17" width="17" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 0C4.79086 0 3 1.79086 3 4C3 6.20914 4.79086 8 7 8C9.20914 8 11 6.20914 11 4C11 1.79086 9.20914 0 7 0ZM2.00873 9C0.903151 9 0 9.88687 0 11C0 12.6912 0.83281 13.9663 2.13499 14.7966C3.41697 15.614 5.14526 16 7 16C7.41085 16 7.8155 15.9811 8.21047 15.9427C7.45316 15.0003 7 13.8031 7 12.5C7 11.1704 7.47182 9.95094 8.25716 9L2.00873 9ZM8 12.5C8 14.9853 10.0147 17 12.5 17C14.9853 17 17 14.9853 17 12.5C17 10.0147 14.9853 8 12.5 8C10.0147 8 8 10.0147 8 12.5ZM10.4039 15.3032L15.3032 10.4039C15.7408 10.9882 16 11.7138 16 12.5C16 14.433 14.433 16 12.5 16C11.7138 16 10.9882 15.7408 10.4039 15.3032ZM9.69678 14.596C9.25919 14.0118 9 13.2861 9 12.5C9 10.567 10.567 9 12.5 9C13.2861 9 14.0118 9.25919 14.596 9.69678L9.69678 14.596Z" fill="currentColor"/>
    </svg>
  );
}

IconBlockUser.propTypes = {
  className: PropTypes.string,
};
